import { render, staticRenderFns } from "./Barrierefreiheit.vue?vue&type=template&id=7bc88552&scoped=true&"
import script from "./Barrierefreiheit.vue?vue&type=script&lang=js&"
export * from "./Barrierefreiheit.vue?vue&type=script&lang=js&"
import style0 from "./Barrierefreiheit.vue?vue&type=style&index=0&id=7bc88552&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc88552",
  null
  
)

export default component.exports